/* eslint-disable @typescript-eslint/no-var-requires */
const deepMerge = require('deepmerge');
const generalConfig = require('./config.json');

let environmentConfig;

if (process.env.VUE_APP_CONFIG_ENV === 'production') {
    environmentConfig = require('./config.production.json');
} else {
    // config defaults to staging
    environmentConfig = require('./config.staging.json');
}

const config = deepMerge(generalConfig, environmentConfig);

module.exports = config;
